import type { ComponentPropsWithRef } from 'react';

import styles from '@/components/book/Button.module.css';

interface ButtonProps extends ComponentPropsWithRef<'button'> {
  /** `solid`: the one primary act (File it). `line`: a secondary act. `text`: an underlined word. */
  variant?: 'solid' | 'line' | 'text';
}

export function Button({ variant = 'text', className, type = 'button', ...rest }: ButtonProps) {
  return <button type={type} className={[styles[variant], className ?? ''].filter(Boolean).join(' ')} {...rest} />;
}
